




const BASE_API = "https://api.invokeapp.io/api/v1/"
// REACT_APP_CORE_API permite apuntar a un core local SIN tocar este fichero
// (p. ej. `REACT_APP_CORE_API=http://localhost:8000/api/v1/ npm start`).
// En el build de produccion no se define y manda el core de produccion.
const CORE_API = process.env.REACT_APP_CORE_API || "https://api.core.invokeapp.io/api/v1/"

// const BASE_API = "http://localhost:8000/api/v1/"
// const BASE_API = "http://127.0.0.1:8000/api/v1/"
// const CORE_API = "http://127.0.0.1:8000/api/v1/"


export const constants = {
    signUp: CORE_API+"auth/registration/",
    signIn: CORE_API+"auth/token/",
    // contactUs: BASE_API+"contact/us",



    // V1 ANTICITERA API
    // getThreeArticles: BASE_API+"blog/threearticles/",
    // getLastArticles: BASE_API+"blog/articles/",
    // getUniqueArticle: BASE_API+"blog/article/",

    // OJO: las rutas public/blog/* de abajo están COMENTADAS en el core
    // (apps/api/public_urls.py) y responden 404. El blog se migró al Headless CMS
    // y lo sirve Next.js. Se dejan solo porque las usan páginas del blog de este
    // proyecto que ya no están enrutadas. Para leer artículos: getHeadlessCMS.
    getMixin: CORE_API+"public/blog/mixed",

    getThreeArticles: CORE_API+"public/blog/threearticles",
    getLastArticles: CORE_API+"public/blog/articles",
    
    getUniqueArticle: CORE_API+"public/blog/article/",
    getUniqueTutorial: CORE_API+"public/blog/tutorial/",
    

    
    // Feed REAL del blog: el mismo Headless CMS que usa Next.js para /blog. Es
    // público y va por `token` = prov del CMS (ver lib/blogFeed.js).
    getHeadlessCMS: CORE_API+"integrations/headless-cms",
    blogCmsProv: "prov_yk7fOxOk6OA6Hwealx2SvQ",

    getPlatforms: CORE_API+"public/integrations/get-platforms",
    getIntegrations: CORE_API+"public/integrations/get-integrations",
    getPlaybooks: CORE_API+"public/integrations/get-playbooks",
    getOperators: CORE_API+"public/operators/list",
    // Demo de un playbook con la marca de la agencia (/playbook-demo):
    // ?pb=<playbook_uuid>&by=<company_uuid>. Una sola peticion, sin sesion.
    getPlaybookDemo: CORE_API+"public/integrations/playbook-demo",
    // Componentes embebibles (iframe) de los playbooks para la web de la agencia.
    // Publico: ?key=<clave de insercion>&pb=<playbook_uuid>[&process=<process_key>]
    getPlaybookEmbed: CORE_API+"public/integrations/playbook-embed",
    // Marca de una agencia sin playbook (?by=<company_uuid>): páginas de próximos lanzamientos.
    getAgencyBrand: CORE_API+"public/integrations/agency-brand",
    // Autenticado (Customer Portal): GET lista / POST crea; <uuid>/revoke revoca.
    playbookEmbedKeys: CORE_API+"integrations/playbook-embed-keys",
    
    getProducts: CORE_API+"subscriptions/get-stripe-products",
    // Checkout PUBLICO (visitante sin cuenta): el webhook resuelve/crea la cuenta por email.
    createPublicCheckout: CORE_API+"subscriptions/create-public-checkout/",
    
    // getProducts: CORE_API+"public/subscriptions/get-stripe-products",


    

    getTags: BASE_API+"tags/getall",

    postCommentBlog: BASE_API+"blog/create_comment/",
    getSingleComment: BASE_API+"blog/get_single_comment/",
    getThreeComments: BASE_API+"blog/threecomments",

    getProjects: BASE_API+"projects/getworks",
    getCustomersLogo: BASE_API+"projects/getlogocustomers",

    createUserNewsletter: BASE_API+"blog/create-user-newsletter",



    createUserPrelaunch: CORE_API+"settings/create-user-prelaunch",
    contactUs: CORE_API+"settings/contact-us",
    affiliateApplication: CORE_API+"settings/affiliate-application",
    createUserAccount: CORE_API+"accounts/create-user",
    readUsersCompany: CORE_API+"accounts/read-users-company",
    // Onboarding del Customer Portal: estado de suscripcion y ficha de empresa.
    subscriptionStatus: CORE_API+"subscriptions/subscription-status",
    readCurrentCompany: CORE_API+"accounts/read-current-company",
    updateCompany: CORE_API+"accounts/update-company",
    updatePrivateCompany: CORE_API+"accounts/update-private-company",
    uploadCompanyLogo: CORE_API+"accounts/upload-company-logo",
    // App de agencia (contrato docs/agency-app/CONTRATO-AGENCY-APP.md) y su vista previa real (contrato v1).
    agencyAppConfig: CORE_API+"agency-app/config",
    agencyAppSlugCheck: CORE_API+"agency-app/slug-check",
    agencyAppPreviewUrl: process.env.REACT_APP_AGENCY_APP_PREVIEW_URL || "https://preview.app.invokeapp.io/",
    createEmployee: CORE_API+"accounts/create-employee",

    // Lead magnet (landing /resources/ai-kit). Crea el LEAD en el CRM, devuelve
    // el contenido ya renderizado y encola el correo como copia. Es publico y
    // tiene CORS abierto a proposito (apps/integrations/cors_public.py), porque
    // lo llaman formularios alojados en dominios de clientes.
    leadMagnet: CORE_API+"integrations/launch/lead-magnet-crm-email",
    // Variante que SOLO crea el lead (sin correo ni contenido). La usa el popup
    // de captación de la home: ver LEAD_FORMS en src/lib/aiKit.js.
    leadMagnetHtmlForm: CORE_API+"integrations/launch/lead-magnet-html-form",

}




export const colors = {
    mainPurple: "#7C74FF",
    mainCian: "#00FFFF",
    // mainGrey: "#D8DBF1"
    mainGrey: "#E8E8E8"
}


export const businessLogic = {
    domain: "https://invokeapp.io",
    // Imagen de previsualización al compartir (OG/Twitter). TODO: sustituir por una imagen dedicada 1200x630.
    ogImage: "https://invokeapp.io/assets/img/logo/logo-black.png",
    emailBase: "letstalk@invokeapp.io",
    contactEmail: "contact@invokeapp.io",
    address: "Madrid (Spain)",
    // phoneNumber: "(404) 888 123 456",
    phoneNumber: "",
    whatsappNumber: "+34604819607",
    whatsappLink: "https://wa.me/34604819607",
    whatsappCommunityLink: "https://chat.whatsapp.com/E39woncplRM02x4qsnBmrs",
    meetupCommunityLink: "https://www.meetup.com/ia-para-agencias-freelancers-y-consultores/",
    // Agenda de la auditoría de IA gratuita para agencias (banner de la home).
    aiAuditLink: "https://calendar.app.google/KQCsGefDmnDY3pC86",
    scaActivationUrl: "https://sca.core.invokeapp.io/sca/hasttest/form/",
    // Sesion de descubrimiento embebida en /platform. El servicio no manda
    // X-Frame-Options ni frame-ancestors, por eso se puede meter en iframe.
    // OJO: "hashtest" es un token de PRUEBA y aqui queda PUBLICO —
    // sustituir por el token/tenant de demo definitivo antes de publicar.
    discoveryEmbedUrl: "https://discovery.core.invokeapp.io/?token=hashtest",
    // Portal de conexion segura (SCA). Mismo token de PRUEBA y mismo aviso:
    // sustituir por el definitivo antes de publicar.
    scaEmbedUrl: "https://sca.core.invokeapp.io/?token=hashtest",
    scaActivationPreviewJson: "https://storage.googleapis.com/invokeapp-assets/invoke-app-space/sca/test/hasttest.json",
    // linkedin: "https://www.linkedin.com/in/invoke-app-85a212266/",
    linkedin: "https://www.linkedin.com/company/invokeapp/",
    x: "https://x.com/invokeapp_saas",
    instagram:"https://www.instagram.com/invokeapp/",
    facebook:"https://www.facebook.com/invokeapp",
    tiktok:"https://www.tiktok.com/@invoke_app",
    youtube:"https://www.youtube.com/@invokeapp",
    copyright: "Copyright © 2026 MARTÍNEZ CAMPOY CONSULTING, S.L. · InvokeApp",
    logoBlack: "logo-black.png",
    // logoBlack: "logo-ia-black.png",
    logoWhite: "logo-white.svg",
    logoCian: "logo-cian.svg",
    logoNegative: "logo-negative.svg",
    logoPurple: "logo-purple.svg",
    // logoWhite: "logo-ia-white.png"

    mobile_landing: "https://seed.invokeapp.io",
    backend_landing: "https://growth.invokeapp.io",
    consulting_landing: "https://techconsult.invokeapp.io",
    database_landing: "https://scaleup.invokeapp.io",
    data_landing: "https://datainsights.invokeapp.io",
    uiux_landing: "https://preseed.invokeapp.io",
    webapps_landing: "https://appignite.invokeapp.io",
    saas_landing: "https://maturity.invokeapp.io"

}


// Meter la tarjeta o codigos en stripe o la plataforma cobrar un pago si no suspenden
// 